
export const root = {
  transitionDuration: '{transition.duration}'
};

export const track = {
  background: 'var(--grey-100)',
  borderRadius: '{content.border.radius}',
  size: '3px'
};

export const range = {
  background: 'var(--primary-blue-100)'
};

export const handle = {
  width: '20px',
  height: '20px',
  borderRadius: '50%',
  background: 'var(--white-100)',
  hoverBackground: 'var(--white-100)',
  content: {
    background: 'var(--primary-blue-100)',
    borderRadius: '50%',
    hoverBackground: 'var(--primary-blue-100)',
    width: '16px',
    height: '16px',
    shadow: '0px 0.5px 0px 0px rgba(0, 0, 0, 0.08), 0px 1px 1px 0px rgba(0, 0, 0, 0.14)'
  },
  focusRing: {
    width: '{focus.ring.width}',
    style: '{focus.ring.style}',
    color: 'var(--primary-blue-100)',
    offset: '{focus.ring.offset}',
    shadow: '{focus.ring.shadow}'
  }
};

export const colorScheme = {
  light: {
    handle: {
      content: {
        background: 'var(--primary-blue-100)'
      }
    }
  },
  dark: {
    handle: {
      content: {
        background: '{surface.950}'
      }
    }
  }
};

export default {
  root,
  track,
  range,
  handle,
  colorScheme
}